import { useState, ChangeEvent } from 'react';
import cn from 'classnames';
import { ReactComponent as CloseIcon } from '../assets/close.svg';

import styles from './SearchInput.module.scss';

export interface SearchInputProps {
  value?: string;
  onChange?: (value: string) => void;
  placeholder?: string;
  hint?: string;
  className?: string;
  id?: string;
  isDisabled?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value = '',
  onChange,
  placeholder = 'Search...',
  hint,
  className,
  id,
  isDisabled = false,
}) => {
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange?.(newValue);
  };

  const handleClear = () => {
    setInputValue('');
    onChange?.('');
  };

  return (
    <div className={styles.searchInputContainer}>
      <div className={cn(styles.searchInputWrapper, className)}>
        <input
          type="text"
          value={inputValue}
          onChange={handleChange}
          placeholder={placeholder}
          className={styles.searchInput}
          id={id}
          disabled={isDisabled}
        />
        {inputValue && (
          <button
            type="button"
            onClick={handleClear}
            className={styles.clearButton}
            aria-label="Clear search"
          >
            <CloseIcon />
          </button>
        )}
      </div>
      {hint && <p className={styles.hintText}>{hint}</p>}
    </div>
  );
};
